import * as React from "react"
import type { IconProps } from "../types"

const Truck = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, strokeWidth = 1.5, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
          d="M10 16.25H14.5M4.71429 16.25H2.75V10L5 6.75H8.75V15M19.3561 16.25H21.25V4.75H8.75V6.84091M9.75 16.75C9.75 18.1307 8.63071 19.25 7.25 19.25C5.86929 19.25 4.75 18.1307 4.75 16.75C4.75 15.3693 5.86929 14.25 7.25 14.25C8.63071 14.25 9.75 15.3693 9.75 16.75ZM19.25 16.75C19.25 18.1307 18.1307 19.25 16.75 19.25C15.3693 19.25 14.25 18.1307 14.25 16.75C14.25 15.3693 15.3693 14.25 16.75 14.25C18.1307 14.25 19.25 15.3693 19.25 16.75Z"
        />
      </svg>
    )
  }
)
Truck.displayName = "Truck"

export default Truck
